import React, { useState, useEffect } from 'react';
import CloudPlatformSec from "../../components/cloud-platform";
import { Link } from "react-router-dom";
import {
     Input,
     FormFeedback,
     Form, 
     Modal,
     ModalBody,
   } from "reactstrap";

const unitToMB = (size, unit) => {
  if (unit === "GB") return size * 1024;
  if (unit === "TB") return size * 1024 * 1024;
  return size;
};

export default function App() {
  const [form, setForm] = useState({
    cpu: "",
    ram: "",
    ssdSize: "",
    ssdUnit: "GB",
    storageSize: "",
    storageUnit: "GB",
    bandwidth: "10",
    ipQty: "",
    mode: "cumulative",
  });

  const [result, setResult] = useState("");
  const [cart, setCart] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);

  const rates = {
    cpu: 250, // per vCPU month
    ram: 200, // per GB month
    storage: 11, // per GB month
    ip: 750, // per IP month
    windows: 600, // per cpu per month
    windows_datacenter_edition: 792.5, // per core
    ubuntu: 0, // free
  };

  useEffect(() => {
    const savedCart = sessionStorage.getItem('cart');
    if (savedCart) {
      const cartItems = JSON.parse(savedCart);
      setCart(cartItems);
      calculateCartTotal(cartItems);
    }
  }, []);
  const [modal, setModal] = useState(false);
    const toggle = () => {
         if (modal) {
           setModal(false);
         } else {
           setModal(true);
         }
       };
      const [getInTouchContactForm, setInTuchPlanModal] = useState(false);
      const planGetIntuchToggle = () => {
        if (getInTouchContactForm) {
            setInTuchPlanModal(false);
        } else {
            setInTuchPlanModal(true);
        }
      };
      
    
      const openGetInTouchContactForm = () => {
            setInTuchPlanModal(true);
      };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const addToCart = () => {
    if (!result) return;
    
    const cpuPrice = parseInt(form.cpu || 0) * rates.cpu;
    const ramPrice = parseFloat(form.ram || 0) * rates.ram;
    const storageGB = form.storageUnit === "TB" ? parseFloat(form.storageSize || 0) * 1024 :
                     form.storageUnit === "MB" ? parseFloat(form.storageSize || 0) / 1024 :
                     parseFloat(form.storageSize || 0);
    const storagePrice = storageGB * rates.storage;
    const osPrice = form.os === "Windows" ? parseInt(form.cpu || 0) * rates.windows : rates.ubuntu;
    const ipPrice = parseInt(form.ipQty || 0) * rates.ip;
    const itemTotal = cpuPrice + ramPrice + storagePrice + osPrice + ipPrice;
    
    const cartItem = {
      id: Date.now(),
      config: `${form.cpu}vCPU, ${form.ram}GB RAM, ${form.storageSize}${form.storageUnit} Storage`,
      price: itemTotal
    };
    
    const newCart = [...cart, cartItem];
    setCart(newCart);
    sessionStorage.setItem('cart', JSON.stringify(newCart));
    calculateCartTotal(newCart);
  };

  const removeFromCart = (itemId) => {
    const newCart = cart.filter(item => item.id !== itemId);
    setCart(newCart);
    sessionStorage.setItem('cart', JSON.stringify(newCart));
    calculateCartTotal(newCart);
  };

  const calculateCartTotal = (cartItems) => {
    const subtotal = cartItems.reduce((sum, item) => sum + item.price, 0);
    const discount = cartItems.length >= 5 ? subtotal * 0.05 : 0;
    setCartTotal(subtotal - discount);
  };

  const calculate = () => {
    try {
      const cpuPrice = parseInt(form.cpu) * rates.cpu;
      const ramPrice = parseFloat(form.ram) * rates.ram;
      
      const storageGB = form.storageUnit === "TB" ? parseFloat(form.storageSize) * 1024 :
                       form.storageUnit === "MB" ? parseFloat(form.storageSize) / 1024 :
                       parseFloat(form.storageSize);
      const storagePrice = storageGB * rates.storage;
      
      let osPrice = 0;
      
      if (form.os === "Windows") {
        osPrice = parseInt(form.cpu || 0) * rates.windows;
      } else if (form.os === "Windows DataCenter Edition") {
        osPrice = parseInt(form.cpu || 0) * rates.windows_datacenter_edition;
      } else {
        osPrice = rates.ubuntu;
      }

      if (
        form.cpu == 48 &&
        form.ram == 192 &&
        form.os === "Windows DataCenter Edition"
      ) {
        osPrice = 2161.70;
      }
      
      const ipPrice = parseInt(form.ipQty || 0) * rates.ip;

      if (form.mode === "separate") {
        setResult(
          `VM Compute: ₹ ${(cpuPrice + ramPrice + osPrice).toFixed(2)}
` +
          `Storage: ₹ ${storagePrice.toFixed(2)}
` +
          `Static IP: ₹ ${ipPrice.toFixed(2)}`
        );
      } else {
        const total = cpuPrice + ramPrice + storagePrice + osPrice + ipPrice;
        setResult(`Total Price: ₹ ${total.toFixed(2)} - Monthly Cost (Taxes are Excluded)`);
      }
    } catch (err) {
      setResult("Please enter valid numbers");
    }
  };

  return (
    <>
      <div className="page_heading">
        <div className="container">
          <h1>CALCULATE PRICING</h1>
        </div>
      </div>

      <div className="container calculator-page-section">
        <div className="intro-text">
          <h2>Estimate Your Cloud Costs in Real Time</h2>
          <p>Use our interactive Cloud Pricing Calculator to build your ideal setup based on compute, storage, and bandwidth needs. Whether you're a startup or enterprise, get real-time pricing that fits your exact requirements.</p>
        </div>

        <div className="calculator-main-content">
          <div className="how-to-use">
            <h3>How to Use the Calculator</h3>
            <p>(Example: Hosting a Business Web Application)</p>
            <ol>
              {/*<li>
                <strong>Select Region</strong>
                <p>Pick the nearest data centre for better performance. E.g., choose Mumbai if your users are in Western India.</p>
              </li>*/}
              <li>
                <strong>Set Compute Power</strong>
                <p>Define CPU and RAM needs. E.g., 4 vCPUs + 8 GB RAM for moderate traffic.</p>
              </li>
              <li>
                <strong>Add Storage</strong>
                <p>Choose SSD and extra storage. E.g., 100 GB SSD + 500 GB for backups/logs.</p>
              </li>
              <li>
                <strong>Set Bandwidth & IPs</strong>
                <p>Enter monthly bandwidth and static IPs. E.g., 2 TB/month + 1 static IP.</p>
              </li>
              {/* <li>
                <strong>Choose Pricing View</strong>
                <p>See pricing per resource or bundled total. E.g., select "Cumulative" for a full estimate.</p>
              </li> */}
              <li>
                <strong>Get Instant Estimate</strong>
                <p>Adjust inputs and see costs update live.</p>
              </li>
            </ol>
          </div>

          <div className="calculator-container">
            <h3>Cloud Pricing Calculator</h3>

            {/*<div className="form-row">
              <label>Region:</label>
              <select name="Region" onChange={handleChange} className="input">
                {["Select Region", "Gandhinagar", "Chennai", "Mumbai"].map((bw) => (
                  <option key={bw} value={bw}>{bw}</option>
                ))}
              </select>
            </div>*/}
            <div className="form-row">
              <label>vCPUs:</label>
              <input name="cpu" onChange={handleChange} className="input" placeholder="" />
            </div>
            
            <div className="form-row">
              <label>RAM (GB):</label>
              <input name="ram" onChange={handleChange} className="input" placeholder="" />
            </div>
            
            <div className="form-row hidden" style={{ display: "none" }}>
              <label>SSD Size:</label>
              <div className="input-group">
                <input name="ssdSize" onChange={handleChange} className="input" placeholder="" />
                <select name="ssdUnit" value={form.ssdUnit} onChange={handleChange} className="select">
                  <option value="MB">MB</option>
                  <option value="GB">GB</option>
                </select>
              </div>
            </div>
            
            <div className="form-row">
              <label>Storage Size:</label>
              <div className="input-group">
                <input name="storageSize" onChange={handleChange} className="input" placeholder="" />
                <select name="storageUnit" value={form.storageUnit} onChange={handleChange} className="select">
                  <option value="GB">GB</option>
                  <option value="TB">TB</option>
                  
                </select>
              </div>
            </div>
            
            <div className="form-row" style={{ display: "none" }}>
              <label>Bandwidth:</label>
              <select name="bandwidth" value={form.bandwidth} onChange={handleChange} className="input">
                {["10", "50", "100", "200", "500", "1024"].map((bw) => (
                  <option key={bw} value={bw}>{bw} MB</option>
                ))}
              </select>
            </div>

            <div className="form-row">
              <label>Operating System:</label>
              <select name="os" onChange={handleChange} className="input">
                {["Ubuntu", "Windows","Windows DataCenter Edition"].map((bw) => (
                  <option key={bw} value={bw}>{bw}</option>
                ))}
              </select>
            </div>
            
            <div className="form-row">
              <label>Static IPs:</label>
              <input name="ipQty" onChange={handleChange} className="input" placeholder="" />
            </div>

            <div className="form-row" style={{ display: "none" }}>
              <label>Mode:</label>
              <div className="radio-group">
                <label className="radio-label">
                  <input type="radio" name="mode" value="separate" checked={form.mode === 'separate'} onChange={handleChange} />
                  Separate
                </label>
                <label className="radio-label">
                  <input type="radio" name="mode" value="cumulative" checked={form.mode === 'cumulative'} onChange={handleChange} />
                  Cumulative
                </label>
              </div>
            </div>

            <button onClick={calculate} className="calculate-btn">
              Calculate
            </button>
            
            {/* The "Add to Cart" button is part of the original logic, so we keep it. */}
            <button onClick={addToCart} className="cart-btn hidden" disabled={!result}>
              Add to Cart
            </button>

            {result && <pre className="result">{result}</pre>}
            
            {cart.length > 0 && (
              <div className="cart">
                <h3>Cart ({cart.length} items)</h3>
                <div className="cart-table">
                  <div className="cart-header">
                    <span>Configuration</span>
                    <span>Price</span>
                    <span>Action</span>
                  </div>
                  {cart.map(item => (
                    <div key={item.id} className="cart-row">
                      <span className="config">{item.config}</span>
                      <span className="price">₹{item.price.toFixed(2)}</span>
                      <button className="remove-btn" onClick={() => removeFromCart(item.id)}>Remove</button>
                    </div>
                  ))}
                </div>
                {cart.length >= 5 && <div className="discount">Discount (5%): -₹{(cart.reduce((sum, item) => sum + item.price, 0) * 0.05).toFixed(2)}</div>}
                <div className="total">Total: ₹{cartTotal.toFixed(2)} Monthly</div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="features-section">
          <div className="container">
              <div className="feature">
                  <div className="icon-placeholder"><img src="/static/transprent_price.png"></img></div>
                  <h4>Transparent Pricing</h4>
                  <p>No hidden fees</p>
              </div>
              <div className="feature">
                  <div className="icon-placeholder"><img src="/static/sovereign.png"></img></div>
                  <h4>India-Centric</h4>
                  <p>MeitY-empanelled DCs in Mumbai, Chennai, Gandhinagar</p>
              </div>
              <div className="feature">
                  <div className="icon-placeholder"><img src="/static/Compliance.png"></img></div>
                  <h4>Fully Customisable</h4>
                  <p>Tailored to your workload</p>
              </div>
              <div className="feature">
                  <div className="icon-placeholder"><img src="/static/high_avail.png"></img></div>
                  <h4>Enterprise-Grade Security</h4>
                  <p>Rated-3 data centre hosting</p>
              </div>
          </div>
      </div>

      <div className="need-help-section">
          <div className="container">
              <h3 className='text-white'>Need help deciding the right setup?</h3>
              <p>Talk to our cloud experts or request a custom quote.</p>
              <button className="get-in-touch-btn cloud-calculator" onClick={() => openGetInTouchContactForm()}>GET IN TOUCH</button>
          </div>
      </div>
      <Modal isOpen={getInTouchContactForm} toggle={getInTouchContactForm}>
          <ModalBody>
          <Link className="close1" onClick={(e) => { e.preventDefault(); planGetIntuchToggle(); }}>×</Link>
                <div className="Mobile_getin_tuch">
                  <CloudPlatformSec homeData={[]} pageName="CloudCalculater" />
                </div>
          </ModalBody>
      </Modal>
      {/* 
      <a href="javascript:void(0)" className="enquire-now-side-btn" onClick={() => openGetInTouchContactForm()}>GET IN TOUCH</a> */}
      <style jsx>{`
        .page_heading {
          padding: 50px 0;
          text-align: center;
          color: white;
        }
        .page_heading h1 {
          font-size: 2.5rem;
          font-weight: bold;
        }

        .calculator-page-section {
          padding: 40px 20px;
        }
        .hidden {
          display: none;
        }

        .intro-text {
          text-align: center;
          margin-bottom: 40px;
        }
        .intro-text h2 {
          font-size: 2.2rem;
          margin-bottom: 10px;
          color: #333;
          font-weight: 600;
        }
        .intro-text p {
          font-size: 1.1rem;
          color: #666;
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .calculator-main-content {
          display: flex;
          gap: 40px;
          align-items: flex-start;
          max-width: 1200px;
          margin: 0 auto;
        }

        .how-to-use {
          flex: 1;
          padding-right: 20px;
        }
        .how-to-use h3 {
          font-size: 1.5rem;
          margin-bottom: 10px;
          font-weight: 600;
        }
        .how-to-use > p {
            color: #555;
            margin-bottom: 20px;
        }
        .how-to-use ol {
          list-style: none;
          padding-left: 0;
          counter-reset: item;
        }
        .how-to-use li {
          margin-bottom: 20px;
          position: relative;
          padding-left: 35px;
        }
        .how-to-use li::before {
            content: counter(item);
            counter-increment: item;
            position: absolute;
            left: 0;
            top: 0;
            background: #f0f0f0;
            width: 25px;
            height: 25px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            color: #333;
        }
        .how-to-use li strong {
          display: block;
          font-size: 1.1rem;
          margin-bottom: 5px;
          font-weight: 600;
        }
        .how-to-use li p {
            font-size: 0.95rem;
            color: #666;
            line-height: 1.5;
        }

        .calculator-container {
          flex: 1;
          padding: 30px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          border: 1px solid #e9ecef;
        }
        .calculator-container h3 {
          text-align: center;
          color: #333;
          margin-bottom: 25px;
          font-size: 1.5rem;
          font-weight: 600;
        }
        .form-row {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          gap: 10px;
        }
        .form-row > label {
          width: 100px;
          font-weight: 500;
          color: #333;
          font-size: 0.95rem;
          text-align: left;
        }
        .input, .select {
          flex: 1;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          font-size: 1rem;
        }
        .input-group {
          display: flex;
          gap: 0;
          flex: 1;
        }
        .input-group .input {
          flex: 1;
          border-right: 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        .input-group .select {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          background: #f8f9fa;
          border-color: #ccc;
          min-width: 70px;
        }
        .radio-group {
          display: flex;
          gap: 20px;
          flex: 1;
          align-items: center;
        }
        .radio-label {
          display: flex;
          align-items: center;
          gap: 8px;
          cursor: pointer;
        }
        .radio-label input {
            width: 16px;
            height: 16px;
        }
        .calculate-btn {
          width: 100%;
          padding: 12px;
          background: #00adee;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 1.1rem;
          font-weight: bold;
          cursor: pointer;
          margin: 20px 0 10px 0;
          transition: background 0.3s;
        }
        .calculate-btn:hover {
          background: #008bbd;
        }
        .result {
          margin-top: 20px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 4px;
          border: 1px solid #e9ecef;
          white-space: pre-line;
          font-family: monospace;
        }
        .cart-btn {
          width: 100%;
          padding: 12px;
          background: #6c757d;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          margin: 0;
        }
        .cart-btn:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
        .cart {
          margin-top: 20px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 4px;
          border: 1px solid #e9ecef;
        }
        .cart-table {
          margin: 15px 0;
        }
        .cart-header {
          display: grid;
          grid-template-columns: 2fr 1fr 80px;
          gap: 10px;
          padding: 10px;
          background: #e9ecef;
          border-radius: 4px;
          font-weight: 600;
          margin-bottom: 5px;
        }
        .cart-row {
          display: grid;
          grid-template-columns: 2fr 1fr 80px;
          gap: 10px;
          padding: 12px 10px;
          border-bottom: 1px solid #dee2e6;
          align-items: center;
        }
        .cart-row:last-child {
          border-bottom: none;
        }
        .cart-row .config {
          font-size: 0.9rem;
          color: #333;
        }
        .cart-row .price {
          font-weight: 600;
          color: #00adee;
        }
        .remove-btn {
          padding: 5px 10px;
          background: #dc3545;
          color: white;
          border: none;
          border-radius: 3px;
          font-size: 0.8rem;
          cursor: pointer;
        }
        .remove-btn:hover {
          background: #c82333;
        }
        .discount {
          color: #28a745;
          font-weight: 600;
          margin: 10px 0;
        }
        .total {
          font-size: 1.1rem;
          font-weight: bold;
          color: #333;
          border-top: 2px solid #dee2e6;
          padding-top: 10px;
          margin-top: 10px;
        }
        
        .features-section {
            background: #f8f9fa;
            padding: 50px 20px;
            margin-top: 50px;
        }
        .features-section .container {
            display: flex;
            justify-content: space-around;
            text-align: center;
            max-width: 1200px;
            margin: 0 auto;
            gap: 20px;
        }
        .feature {
            max-width: 220px;
        }
        .icon-placeholder {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background: #e0e0e0;
            margin: 0 auto 15px auto;
            /* TODO: Replace with actual <img> tags once icons are available */
        }
        .feature h4 {
            font-size: 1.1rem;
            margin-bottom: 10px;
            font-weight: 600;
        }
        .feature p {
            font-size: 0.9rem;
            color: #666;
        }

        .need-help-section {
            background: #002b5c;
            color: white;
            padding: 50px 20px;
            text-align: center;
        }
        .need-help-section .container {
            max-width: 1200px;
            margin: 0 auto;
        }
        .need-help-section h3 {
            font-size: 1.8rem;
            margin-bottom: 10px;
            font-weight: 600;
            color: white;
        }
        .need-help-section p {
            margin-bottom: 20px;
            font-size: 1.1rem;
        }
        .get-in-touch-btn {
            background: white;
            color: #002b5c;
            border: none;
            padding: 12px 30px;
            font-size: 1rem;
            font-weight: bold;
            border-radius: 5px;
            cursor: pointer;
            transition: background 0.3s;
        }
        .get-in-touch-btn:hover {
            background: #f0f0f0;
        }

        @media (max-width: 992px) {
          .calculator-main-content {
            flex-direction: column;
          }
          .how-to-use {
            padding-right: 0;
            margin-bottom: 30px;
          }
        }
        @media (max-width: 768px) {
            .features-section .container {
                flex-direction: column;
                align-items: center;
                gap: 30px;
            }
            .intro-text h2 {
                font-size: 1.8rem;
            }
            .page_heading h1 {
                font-size: 2rem;
            }
            .form-row {
                flex-direction: column;
                align-items: stretch;
            }
            .form-row > label {
                width: 100%;
                margin-bottom: 5px;
            }
            .calculator-container {
                padding: 20px 15px;
            }
            .cart-header, .cart-row {
                grid-template-columns: 1fr;
                gap: 5px;
                text-align: center;
            }
            .cart-header {
                display: none;
            }
            .cart-row {
                background: white;
                margin-bottom: 10px;
                padding: 15px;
                border-radius: 5px;
                border: 1px solid #dee2e6;
            }
            .cart-row .config {
                margin-bottom: 8px;
                font-weight: 600;
            }
            .cart-row .price {
                margin-bottom: 8px;
                font-size: 1.1rem;
            }
        }
      `}
    </style>
    </>
  );
}

